import React from 'react';
import PropTypes from 'prop-types';
import { BodyText, Alert } from '@paypalcorp/pp-react';
import { Message } from '@paypalcorp/worldready-react';
export default function RecurringInfo({ orgName, amount }) {
  return (
    <Alert type="info" className="recurring-info">
      <BodyText>
        <Message
          id="common.recurring-checkbox.wr.rp.helpText1"
          orgName={<strong>{orgName}</strong>}
        />
      </BodyText>
    </Alert>
  );
}

RecurringInfo.propTypes = {
  orgName: PropTypes.string,
  amount: PropTypes.string,
};
